import wecomReceiveMessageHook from "./wecom/receive-message-hook";
import wecomGetRoomDetailHook from "./wecom/get-room-detail-hook";
import wecomGetContactDetailHook from "./wecom/get-contact-detail-hook";
import wecomRevocateMessageHook from "./wecom/revocate-message-hook";
import wecomRemoveCustomerToRoomHook from "./wecom/remove-customer-to-room-hook";
import conversationChangeHook from "./wecom/conversation-change-hook";
import conversationStatusChangeHook from "./wecom/conversation-status-change-hook";
import wecomUnreadNumUpdateHook from "./wecom/unread-num-update-hook";
import wechatReceiveMessageHook from "./wechat/receive-message-hook";
import wechatAcceptFriendHook from "./wechat/accept-friend-hook";
import wechatGetRoomDetailHook from "./wechat/get-room-detail-hook";
import wechatGetContactDetailHook from "./wechat/get-contact-detail-hook";
import wechatRevocateMessageHook from "./wechat/revocate-message-hook";
import wechatRemoveCustomerToRoomHook from "./wechat/remove-customer-to-room-hook";
import wechatConversationChangeHook from "./wechat/conversation-change-hook";
import wechatConversationStatusChangeHook from "./wechat/conversation-status-change-hook";
import wechatUnreadNumUpdateHook from "./wechat/unread-num-update-hook";
import wechatReceiveNewFriendApplyHook from "./wechat/receive-new-friend-apply";
import wechatFriendDeleteHook from "./wechat/friend-delete-hook";
import wsErrorHook from "./common/ws-error-hook";
import autoReconnectionFailedHook from "./common/auto-reconnection-failed-hook";
import loginSuccessHook from "./common/login-success-hook";
import logoutHook from "./common/logout-hook";
import receiveLoginQRCodeHook from "./common/receive-login-qrcode";
import scaningHook from "./common/scaning-hook";
import verifyVerificationCodeHook from "./common/verify-verification-code-hook";
import wsConnectStatusChangeHook from "./common/ws-connect-status-change-hook";
import globalChannelMessageHook from "./common/global-channel-message-hook";
import sendMessageError from "./common/send-message-error";
import mailConversationChangeHook from "./mail/conversation-change-hook";
import mailConversationStatusChangeHook from "./mail/conversation-status-change-hook";
import mailUnreadNumUpdateHook from "./mail/unread-num-update-hook";
import mailGetContactDetailHook from "./mail/get-contact-detail-hook";
import mailReceiveMessageHook from "./mail/receive-message-hook";

const chatSdkHooks = {
  common: {
    receiveLoginQRCodeHook,
    scaningHook,
    verifyVerificationCodeHook,
    loginSuccessHook,
    logoutHook,
    wsErrorHook,
    wsConnectStatusChangeHook,
    globalChannelMessageHook,
    sendMessageError,
    autoReconnectionFailedHook,
  },
  wecom: {
    receiveMessageHook: wecomReceiveMessageHook,
    conversationChangeHook: conversationChangeHook,
    conversationStatusChangeHook: conversationStatusChangeHook,
    getRoomDetailHook: wecomGetRoomDetailHook,
    getContactDetailHook: wecomGetContactDetailHook,
    revocateMessageHook: wecomRevocateMessageHook,
    removeCustomerToRoomHook: wecomRemoveCustomerToRoomHook,
    unreadNumUpdateHook: wecomUnreadNumUpdateHook,
  },
  wechat: {
    receiveMessageHook: wechatReceiveMessageHook,
    conversationChangeHook: wechatConversationChangeHook,
    conversationStatusChangeHook: wechatConversationStatusChangeHook,
    acceptFriendHook: wechatAcceptFriendHook,
    getRoomDetailHook: wechatGetRoomDetailHook,
    getContactDetailHook: wechatGetContactDetailHook,
    revocateMessageHook: wechatRevocateMessageHook,
    removeCustomerToRoomHook: wechatRemoveCustomerToRoomHook,
    unreadNumUpdateHook: wechatUnreadNumUpdateHook,
    receiveNewFriendApplyHook: wechatReceiveNewFriendApplyHook,
    friendDeleteHook: wechatFriendDeleteHook,
  },
  mail: {
    conversationChangeHook: mailConversationChangeHook,
    conversationStatusChangeHook: mailConversationStatusChangeHook,
    unreadNumUpdateHook: mailUnreadNumUpdateHook,
    receiveMessageHook: mailReceiveMessageHook,
    getContactDetailHook: mailGetContactDetailHook,
  },
};
export default chatSdkHooks;
